export const NAME = 'analytics';

export const ANALYTICS_ENABLE = 'ANALYTICS_ENABLE';
export const ANALYTICS_DISABLE = 'ANALYTICS_DISABLE';



// WEBPACK FOOTER //
// ./src/services/google/analytics/constants.js